/* Forzly Shift storefront JS: buy box, sticky ATC, gallery, shift slider, cart drawer (gift + upsells). */
(function () {
  var FS = window.FS || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function money(c) {
    var s = new Intl.NumberFormat('en-US', { style: 'currency', currency: FS.currency || 'USD' }).format((c || 0) / 100);
    return s;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function tpl(id) { var t = document.getElementById(id); return t ? t.innerHTML : ''; }
  function pairsOf(name) { var m = /(\d+)\s*pair/i.exec(name || ''); return m ? +m[1] : 1; }
  function img(src, w) { if (!src) return ''; return src.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_' + (w || 160) + 'x$1$2'); }

  /* Announcement rotator (mobile) */
  $$('[data-fs-ann]').forEach(function (el) {
    var items = $$('.fs-ann__item', el), i = 0;
    if (items.length < 2) { items[0] && items[0].classList.add('is-on'); return; }
    items[0].classList.add('is-on');
    setInterval(function () { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 3800);
  });

  /* Menu */
  var menu = $('[data-fs-menu]');
  function setMenu(o) { if (!menu) return; menu.classList.toggle('is-open', o); menu.setAttribute('aria-hidden', o ? 'false' : 'true'); }
  $$('[data-fs-menu-open]').forEach(function (b) { b.addEventListener('click', function () { setMenu(true); }); });
  $$('[data-fs-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });

  /* Reveal */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -6% 0px' });
    $$('.fs-rv').forEach(function (el) { io.observe(el); });
  } else { $$('.fs-rv').forEach(function (el) { el.classList.add('is-in'); }); }

  /* Smooth anchors */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    var t = document.querySelector(a.getAttribute('href'));
    if (t) { e.preventDefault(); if (t.tagName === 'DETAILS') t.open = true; t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  /* Modals */
  function openModal(m) { if (!m) return; m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function closeModal(m) { m.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-fs-modal-open]');
    if (o) { e.preventDefault(); openModal(document.getElementById(o.dataset.fsModalOpen)); return; }
    var c = e.target.closest('[data-fs-modal-close]');
    if (c) { closeModal(c.closest('.fs-modal')); }
  });

  /* Gallery + zoom */
  $$('[data-fs-gal]').forEach(function (g) {
    var slides = $('[data-fs-slides]', g); if (!slides) return;
    var thumbs = $$('[data-fs-thumb]', g), dots = $$('[data-fs-dots] i', g);
    function cur() { return Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)); }
    function go(i) { var n = slides.children.length; i = (i + n) % n; slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' }); }
    slides.addEventListener('scroll', function () { var c = cur(); thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === c); }); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === c); }); }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.fsThumb); }); });
    var p = $('[data-fs-prev]', g), n = $('[data-fs-next]', g);
    p && p.addEventListener('click', function () { go(cur() - 1); });
    n && n.addEventListener('click', function () { go(cur() + 1); });
    var zm = document.getElementById('fs-zoom');
    $$('[data-fs-zoom]', g).forEach(function (s) {
      s.addEventListener('click', function () { if (!zm) return; $('img', zm).src = s.dataset.fsZoom; openModal(zm); });
    });
  });

  /* Clip / review tiles: open bigger in a modal */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fs-vid]'); if (!t) return;
    var m = t.closest('section') && $('.fs-modal--vid', t.closest('section')); if (!m) return;
    var v = $('video', m), im = $('img', m);
    if (t.dataset.fsVid) { v.hidden = false; im.hidden = true; v.src = t.dataset.fsVid; v.muted = true; v.play && v.play().catch(function () {}); }
    else if (t.dataset.fsImg) { v.hidden = true; im.hidden = false; im.src = t.dataset.fsImg; }
    openModal(m);
  });
  document.addEventListener('click', function (e) { var c = e.target.closest('.fs-modal--vid [data-fs-modal-close]'); if (c) { var v = $('video', c.closest('.fs-modal')); v && v.pause(); } });

  /* Shift-collapse slider (illustration) */
  $$('[data-fs-shift]').forEach(function (el) {
    var r = $('input[type=range]', el), hour = $('[data-h]', el), when = $('[data-when]', el), them = $('[data-them]', el), us = $('[data-us]', el), msg = $('[data-msg]', el);
    var themT = $('[data-them-t]', el), usT = $('[data-us-t]', el);
    var msgs = JSON.parse($('[data-msgs]', el).textContent || '[]');
    function f(h) {
      var t = h <= 2 ? 100 - h * 3 : h <= 8 ? 94 - (h - 2) * 6.5 : h <= 12 ? 55 - (h - 8) * 2.5 : 42;
      var u = h <= 12 ? 100 - h * 0.6 : 92;
      return [Math.round(t), Math.round(u)];
    }
    function label(t) { return t >= 85 ? 'Holding' : t >= 65 ? 'Softening' : t >= 50 ? 'Flattening' : 'Crushed'; }
    function render() {
      var h = +r.value, v = f(h);
      hour.textContent = h === 13 ? '6am' : 'Hour ' + h;
      when.textContent = h === 13 ? 'the next morning' : h === 0 ? 'clock in' : 'of your shift';
      them.style.width = v[0] + '%'; us.style.width = v[1] + '%';
      themT.textContent = label(v[0]); usT.textContent = label(v[1]);
      var m = msgs.filter(function (x) { return h >= x.from; }).pop();
      msg.textContent = m ? m.text : '';
    }
    r.addEventListener('input', render); render();
  });

  /* ===== Cart API ===== */
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
  }

  /* ===== Buy box ===== */
  $$('[data-fs-bb]').forEach(function (bb) {
    var cfg = JSON.parse(($('[data-fs-bb-cfg]', bb) || {}).textContent || '{}');
    var variants = cfg.variants || [];
    var tiers = $$('[data-tier]', bb), sizes = $$('[data-size]', bb);
    var atc = $('[data-fs-atc]', bb), label = $('[data-fs-atc-label]', bb);
    var sticky = document.querySelector('[data-fs-sticky]');
    var sLabel = sticky && $('[data-fs-sticky-label]', sticky), sSub = sticky && $('[data-fs-sticky-sub]', sticky);
    var giftRow = $('[data-fs-gift-row]', bb);
    var sheet = bb.closest('section') && $('[data-fs-sheet]', bb.closest('section'));
    var sheetOffer = sheet && $('[data-fs-sheet-offer]', sheet), sheetSizes = sheet ? $$('[data-sheet-size]', sheet) : [];
    var tier = cfg.defaultTier || 2, size = null;
    var pre = variants.filter(function (v) { return v.id === cfg.selected; })[0];
    if (pre && cfg.preselect) { size = pre.size; tier = pairsOf(pre.bundle); }

    var simple = !tiers.length;
    if (simple) { size = 'x'; }
    function find() {
      if (simple) return variants.filter(function (v) { return v.id === cfg.selected; })[0] || variants[0];
      return variants.filter(function (v) { return v.size === size && pairsOf(v.bundle) === tier; })[0];
    }
    function tierPrice() { if (simple) { var s = find(); return s ? s.price : 0; } var v = variants.filter(function (x) { return pairsOf(x.bundle) === tier; })[0]; return v ? v.price : 0; }
    function render() {
      tiers.forEach(function (t) { var on = +t.dataset.tier === tier; t.classList.toggle('is-on', on); t.setAttribute('aria-checked', on); });
      sizes.forEach(function (b) {
        b.classList.toggle('is-on', b.dataset.size === size);
        var v = variants.filter(function (x) { return x.size === b.dataset.size && pairsOf(x.bundle) === tier; })[0];
        b.disabled = !v || !v.available;
      });
      var price = tierPrice();
      var txt = (cfg.cta || 'Add to cart') + ' · ' + money(price);
      if (label) label.textContent = txt;
      if (sLabel) sLabel.textContent = txt;
      if (sSub) sSub.textContent = simple ? money(price) : tier + (tier > 1 ? ' pairs' : ' pair') + (size ? ' · Size ' + size.split(' ')[0] : '');
      if (giftRow) giftRow.classList.toggle('is-locked', tier < (cfg.giftMin || 2));
      if (sheetOffer) { var tb = tiers.filter(function (t) { return +t.dataset.tier === tier; })[0], tn = tb && $('.fs-tier__name', tb); sheetOffer.textContent = (tn ? tn.firstChild.textContent.trim() : tier + (tier > 1 ? ' pairs' : ' pair')) + ' · ' + money(price); }
      sheetSizes.forEach(function (b) {
        b.classList.toggle('is-on', b.dataset.sheetSize === size);
        var v = variants.filter(function (x) { return x.size === b.dataset.sheetSize && pairsOf(x.bundle) === tier; })[0];
        b.disabled = !v || !v.available;
      });
      var v = find();
      if (v && !simple && cfg.updateUrl && window.history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    tiers.forEach(function (t) { t.addEventListener('click', function () { tier = +t.dataset.tier; render(); }); });
    bb.fsPick = function (n) { tier = n; render(); };
    sizes.forEach(function (b) { b.addEventListener('click', function () { size = b.dataset.size; render(); }); });

    /* No size yet: open the size sheet (or gently highlight the inline sizes). No error text. */
    function hintSizes() {
      var s = $('[data-fs-size-anchor]', bb); s && s.scrollIntoView({ behavior: 'smooth', block: 'center' });
      bb.classList.remove('hl-size'); void bb.offsetWidth; bb.classList.add('hl-size');
      setTimeout(function () { bb.classList.remove('hl-size'); }, 2200);
    }
    function openSheet() { if (!sheet) return false; render(); sheet.classList.add('is-open'); sheet.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; return true; }
    function closeSheet() { if (!sheet) return; sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
    bb.fsAsk = function () { if (!openSheet()) hintSizes(); };
    function buy(btn) {
      var v = find();
      if (!v) { bb.fsAsk(); return; }
      btn.setAttribute('disabled', ''); var t = $('span', btn) || btn, old = t.textContent; t.textContent = 'Adding…';
      /* Let the button paint "Adding…" before the network work starts */
      return new Promise(function (r) { requestAnimationFrame(function () { setTimeout(r, 0); }); })
        .then(function () { return addItems([{ id: v.id, quantity: 1 }]); }).then(function () { return syncCart(); }).then(function () { closeSheet(); openDrawer(); })
        .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart.'); })
        .then(function () { btn.removeAttribute('disabled'); t.textContent = old; render(); });
    }
    if (sheet) {
      $$('[data-fs-sheet-close]', sheet).forEach(function (c) { c.addEventListener('click', closeSheet); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
      sheetSizes.forEach(function (b) { b.addEventListener('click', function () { if (b.disabled) return; size = b.dataset.sheetSize; render(); buy(b); }); });
    }
    atc && atc.addEventListener('click', function () { buy(atc); });
    var sb = sticky && $('[data-fs-sticky-btn]', sticky);
    sb && sb.addEventListener('click', function () { buy(sb); });

    if (sticky && atc && 'IntersectionObserver' in window) {
      document.body.classList.add('has-fs-sticky');
      var quick = $('[data-fs-quick]', bb), vis = { atc: false, quick: false }, atcAbove = false;
      var upd = function () { var show = !vis.atc && atcAbove; sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true'); };
      var io2 = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.target === atc) { vis.atc = e.isIntersecting; atcAbove = e.boundingClientRect.top < 0; } else { vis.quick = e.isIntersecting; } });
        upd();
      }, { threshold: 0 });
      io2.observe(atc); if (quick) io2.observe(quick);
    }
    render();
  });

  /* Tier pickers elsewhere on the page: select a tier in the first buy box and scroll to it */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fs-pick-tier]'); if (!t) return;
    var bb = document.querySelector('[data-fs-bb]'); if (!bb) return;
    e.preventDefault(); bb.fsPick && bb.fsPick(+t.dataset.fsPickTier);
    if (bb.fsAsk) bb.fsAsk(); else (document.querySelector('[data-fs-size-anchor]') || bb).scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* ===== Cart drawer ===== */
  var drawer = $('[data-fs-drawer]');
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  $$('[data-fs-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); $$('.fs-modal.is-open').forEach(closeModal); setMenu(false); } });
  $$('[data-fs-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); syncCart().then(openDrawer); }); });

  function heroLines(cart) { return FS.hero ? cart.items.filter(function (i) { return i.product_id === FS.hero.id; }) : []; }
  function linePairs(i) { var o = (i.options_with_values || []).filter(function (x) { return /bundle/i.test(x.name); })[0]; return pairsOf(o ? o.value : i.variant_title); }
  function heroPairs(cart) { return heroLines(cart).reduce(function (a, i) { return a + linePairs(i) * i.quantity; }, 0); }

  /* Keep the free gift in step with the cart: in when 2+ pairs, out otherwise. */
  var syncing = false;
  function syncCart() {
    return getCart().then(function (cart) {
      if (!FS.gift || syncing) { renderCart(cart); return cart; }
      var pairs = heroPairs(cart);
      var g = cart.items.filter(function (i) { return i.variant_id === FS.gift.variant; })[0];
      var want = pairs >= FS.gift.min ? 1 : 0, have = g ? g.quantity : 0;
      if (want === have) { renderCart(cart); return cart; }
      syncing = true;
      var p = have === 0 ? addItems([{ id: FS.gift.variant, quantity: 1, properties: { _gift: 'Free gift' } }]) : changeLine(g.key, want);
      return p.catch(function () {}).then(getCart).then(function (c) { syncing = false; renderCart(c); return c; });
    });
  }

  function renderCart(cart) {
    var body = '', foot = '';
    var pairs = heroPairs(cart), hl = heroLines(cart);
    if (!cart.item_count) {
      body = '<div class="fs-empty"><p class="fs-h3">Your cart is empty</p><p class="fs-muted">Your feet are still waiting for support that lasts the shift.</p><a class="fs-btn" href="/products/' + (FS.hero ? FS.hero.handle : '') + '">Shop Shift Insoles</a></div>';
    } else {
      var giftMin = FS.gift ? FS.gift.min : 2, fsMin = FS.freeShipPairs || 0;
      var pct = Math.min(100, Math.round(pairs / Math.max(giftMin, fsMin || giftMin) * 100));
      var msg = pairs >= giftMin ? '<b>Free pouch unlocked.</b>' + (fsMin && pairs >= fsMin ? ' Free shipping too.' : '') :
        (pairs === 1 ? 'Add a 2nd pair to unlock the <b>free Work + Home Pouch</b>' + (fsMin === 2 ? ' and <b>free shipping</b>' : '') + '.' : 'Pick 2 pairs to unlock your free gift.');
      if (pairs > 0) body += '<div class="fs-prog"><p>' + msg + '</p><div class="fs-prog__bar"><i style="width:' + Math.max(pct, 8) + '%"></i></div><div class="fs-prog__marks"><span class="is-on">1 pair</span><span class="' + (pairs >= giftMin ? 'is-on' : '') + '">Free pouch</span>' + (fsMin ? '<span class="' + (pairs >= fsMin ? 'is-on' : '') + '">Free shipping</span>' : '<span class="' + (pairs >= 3 ? 'is-on' : '') + '">Best value</span>') + '</div></div>';
      cart.items.forEach(function (it) {
        var gift = FS.gift && it.variant_id === FS.gift.variant;
        var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : (gift && FS.gift.value ? '<s>' + esc(FS.gift.value) + '</s>' : '');
        var v = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title.replace(/\s*\([^)]*\)/g, '').replace(' / ', ' · ') : '';
        body += '<div class="fs-li' + (gift ? ' fs-li--gift' : '') + '"><img src="' + img(it.image, 160) + '" alt="" loading="lazy"><div><div class="fs-li__t">' + esc(it.product_title) + '</div>' +
          (v ? '<div class="fs-li__v">' + esc(v) + '</div>' : '') + (gift ? '<div class="fs-li__v">Free gift with 2+ pairs</div>' :
          '<div class="fs-qty"><button type="button" data-q="' + it.key + '" data-v="' + (it.quantity - 1) + '" aria-label="Less">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + it.key + '" data-v="' + (it.quantity + 1) + '" aria-label="More">+</button></div><button class="fs-li__rm" type="button" data-q="' + it.key + '" data-v="0">Remove</button>') +
          '</div><div class="fs-li__p">' + was + (gift ? 'FREE' : money(it.final_line_price)) + '</div></div>';
      });
      /* Nudge: 1 pair -> 2 pairs (work + home) */
      var one = hl.filter(function (i) { return linePairs(i) === 1 && i.quantity === 1; })[0];
      if (one && pairs === 1 && FS.hero) {
        var sz = (one.options_with_values || [])[0], two = FS.hero.variants.filter(function (v) { return v.o1 === (sz && sz.value) && pairsOf(v.o2) === 2; })[0];
        if (two) {
          var add = two.price - one.final_price;
          body += '<div class="fs-up fs-up--nudge"><span class="fs-up__flag">Most pick this</span><div class="fs-up__row"><img src="' + img(one.image, 160) + '" alt=""><div><b>Make it 2 pairs: work + home</b><span>Just <span class="pr">' + money(add) + '</span> more, plus the free Work + Home Pouch.</span></div><button class="fs-btn fs-up__add" type="button" data-swap="' + one.key + '" data-to="' + two.id + '">Upgrade</button></div></div>';
        }
      }
      /* Cross-sells: Slant Board at the cart price, then fresheners */
      [FS.upsell, FS.upsell2].forEach(function (u) {
        if (!u || pairs < 1 || cart.items.some(function (i) { return i.variant_id === u.variant; })) return;
        var cp = u.cartPrice || u.price;
        body += '<div class="fs-up"><span class="fs-up__flag">' + esc(u.flag || 'Add-on deal') + '</span><div class="fs-up__row"><img src="' + (u.image || '') + '" alt=""><div><b>' + esc(u.title) + '</b><span>' + esc(u.pitch || '') + '</span><span class="pr">' + (cp < u.price ? '<s>' + money(u.price) + '</s> ' : '') + money(cp) + '</span></div><button class="fs-btn fs-up__add" type="button" data-add="' + u.variant + '">Add</button></div></div>';
      });
      var saved = cart.items.reduce(function (a, i) { return a + (i.original_line_price - i.final_line_price); }, 0) + hl.reduce(function (a, i) { var v = FS.hero.variants.filter(function (x) { return x.id === i.variant_id; })[0], c = v ? v.cmp : 0; return a + (c > i.price ? (c - i.price) * i.quantity : 0); }, 0);
      foot += (saved > 0 ? '<div class="fs-tot-save"><span>You save</span><span>' + money(saved) + '</span></div>' : '') +
        '<div class="fs-tot"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
        '<p class="fs-small fs-muted" style="margin:0">' + esc(FS.shipNote || 'Shipping and taxes calculated at checkout.') + '</p>' +
        '<form action="/cart" method="post"><button class="fs-btn fs-btn--block fs-btn--xl fs-btn--shine" type="submit" name="checkout">' + tpl('fs-ic-lock') + ' Secure checkout</button></form>' +
        '<div class="fs-drw__trust"><span>' + tpl('fs-ic-shield') + '90-day guarantee</span><span>' + tpl('fs-ic-swap') + 'Free size swap</span><span>' + tpl('fs-ic-truck') + 'Tracked shipping</span></div>';
    }
    var b = $('[data-fs-cart-body]'), f = $('[data-fs-cart-foot]');
    if (b) b.innerHTML = body; if (f) f.innerHTML = foot;
    /* /cart page: same content as the drawer, with its own empty state */
    var pb = $('[data-fs-cart-page-body]'), pf = $('[data-fs-cart-page-foot]');
    if (pb) pb.innerHTML = cart.item_count ? body : '<div class="fs-empty"><p class="fs-h3">Your cart is empty</p><a class="fs-btn" href="/products/forzly-shift-insoles">Shop Forzly Shift Insoles</a></div>';
    if (pf) pf.innerHTML = foot;
    $$('[data-fs-count]').forEach(function (c) { c.textContent = cart.item_count || ''; });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-q]');
    if (q) { e.preventDefault(); q.disabled = true; changeLine(q.dataset.q, +q.dataset.v).then(syncCart); return; }
    var a = e.target.closest('[data-add]');
    if (a) { e.preventDefault(); var old = a.textContent, inDrawer = !!a.closest('[data-fs-drawer]'); a.disabled = true; a.textContent = '…'; addItems([{ id: +a.dataset.add, quantity: 1 }]).then(syncCart).then(function () { if (!inDrawer) { a.disabled = false; a.textContent = old; openDrawer(); } }).catch(function () { a.disabled = false; a.textContent = old; }); return; }
    var s = e.target.closest('[data-swap]');
    if (s) { e.preventDefault(); s.disabled = true; s.textContent = '…'; changeLine(s.dataset.swap, 0).then(function () { return addItems([{ id: +s.dataset.to, quantity: 1 }]); }).then(syncCart).catch(syncCart); }
  });

  window.FScart = { open: function () { syncCart().then(openDrawer); }, refresh: syncCart };
  if (document.body.classList.contains('tpl-cart')) syncCart().then(openDrawer); else getCart().then(function (c) { $$('[data-fs-count]').forEach(function (x) { x.textContent = c.item_count || ''; }); });
})();
(function(){function fsBg(){document.querySelectorAll('.fs-gal__slide').forEach(function(s){var i=s.querySelector('img');if(!i)return;var u=i.currentSrc||i.getAttribute('src')||i.getAttribute('data-src');if(u)s.style.setProperty('--fs-bg','url("'+u+'")');});}document.addEventListener('DOMContentLoaded',fsBg);window.addEventListener('load',fsBg);if(document.readyState!=='loading')fsBg();})();